<template>
  <div class="step">
    <div class="text-input">
      <label for="ref" class="subtitle-2 black--text">Référence</label>
      <v-text-field id="ref" v-if="currentStep.order==0" v-model="order.ref" @change="updateRef()" />
    </div>
    <field-group :blocks="currentStep.blocks" flex-direction="column" />
    <v-btn @click="nextStep()" class="themed">Suivant</v-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FieldGroup from "./FieldGroup";
export default {
  components: {
    FieldGroup
  },
  computed: {
    ...mapGetters("orderForm", ["order", "currentStep"])
  },

  data: () => ({
    model: null,
    valid: false,
    formData: {
      isValid: false,
      upcharge: 0
    }
  }),
  watch: {
    formData: {
      deep: true,
      handler(formData) {
        this.$emit("change", formData);
      }
    }
  },
  mounted: function() {
    // this.getStep();
  },
  methods: {
    ...mapActions("orderForm", ["nextStep", "prevStep", "updateRef"]),
    isValid(e) {
      this.valid = e;
      this.$emit("validation", e);
    }
  }
};
</script>
